import useAnnouncementsHistory from '@hooks/query/announcements/useAnnouncementsHistory';
import { PlusOutlined } from '@icon';
import { Button, Drawer, PageHeaderWrapper, Pagination, Typography } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TGetAlertsParams } from '../../types/alerts';
import AlertItem from './components/alert-item';
import AlertsEmpty from './components/alerts-empty';
import AlertsForm from './components/alerts-form';

const Alerts: React.FC = () => {
  const [searchParams, setSearchParams] = React.useState<TGetAlertsParams>({
    page: 1,
    pageSize: 10,
    type: 'all',
  });

  const { drawerProps, close, open } = Drawer.useDrawer();

  const { isFetching, data, refetch } = useAnnouncementsHistory(searchParams, {
    keepPreviousData: true,
  });

  return (
    <PageHeaderWrapper
      extra={
        <Button size="medium" Icon={PlusOutlined} onClick={open}>
          Vytvorenie oznamu
        </Button>
      }
    >
      <AlertsForm fetchHistory={refetch} visible={drawerProps.visible} onClose={close} />
      <Typography display="h5" variant="default" style={{ marginBottom: 16 }}>
        <FormattedMessage id="alerts.history_title" />
      </Typography>
      {!data || data.items.length === 0 ? <AlertsEmpty onAddClick={open} /> : null}
      {data?.items.map((alert, i) => (
        <AlertItem
          method={alert.type === 'email' ? 'EMAIL' : alert.type === 'push' ? 'HILBI' : 'SMS'}
          text={alert.body || alert.message}
          key={alert.id || i}
          createdAt={alert.createdAt}
          deliveredCount={alert.deliveredCount}
          sentCount={alert.sentCount}
          recipientsCount={alert.recipientsCount}
        />
      ))}
      <div style={{ textAlign: 'right', marginTop: 24 }}>
        <Pagination
          current={Number(data?.pagination.current ?? 1)}
          pageSize={Number(data?.pagination.pageSize ?? 10)}
          total={Number(data?.pagination.total ?? 0)}
          onChange={(p) => {
            setSearchParams((o) => ({ ...o, page: p }));
          }}
        />
      </div>
    </PageHeaderWrapper>
  );
};

export default Alerts;
